module.exports = __webpack_public_path__ + "img/O_dark.056a354f.svg";